<template>
  <div>
    <b-row>
      <b-col>
        <h4>セット商品一覧</h4>
      </b-col>
    </b-row>
    <b-row v-show="((nameFilter !== '' || janFilter !== '') && filteredItems != '' && filteredItems.length > 0)">
    <!-- <b-row v-show="((nameFilter !== '' || janFilter !== '') && setInfo != '' && setInfo.length > 0)"> -->
      <b-col sm="10">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
            :items="filteredSetItems" :fields="setFields"
            :janFilter="janFilter">
          <template slot="janCode" slot-scope="row">
            <div class="word-break">{{row.value}}</div>
            <div class="word-break">({{row.item['fnsku']}})</div>
          </template>
          <template slot="remainSetQuantity" slot-scope="row">
            <div><label>{{(row.item['remainSetQuantity'])}} ({{row.item['ableSetQuantity']}})</label></div>
          </template>
          <template slot="additionalCountForSet" slot-scope="row">
            <b-form-input v-model="row.item['additionalCountForSet']"></b-form-input>
          </template>
          <template slot="createSet" slot-scope="row">
            <b-button size="sm" @click="createSet(row)" :disabled="row.item['pairFinalAbleSetQuantity'] == 0 || row.item['pairFinalAbleSetQuantity'] < row.item['additionalCountForSet']" variant="danger">　セット集約　</b-button>
          </template>
          <template slot="createSetMinus" slot-scope="row">
            <b-button size="sm" @click="createSetMinus(row)" :disabled="row.item['preparedSetQuantity'] == 0 || row.item['preparedSetQuantity'] < row.item['additionalCountForSet']" variant="secondary">セット集約解除</b-button>
          </template>
          <template slot="printSetLabel" slot-scope="row">
            <print-barcode-modal-simple
              size="sm" :item="row.item" :memberId="memberId" :variant="'info'" :isSetRow="1"
            />
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row class="component-margin-half" >
      <b-col sm="12">
        <inbound-summary :items="filteredItems"/>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
            :items="filteredItems" :fields="fields"
            :current-page="currentPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="purchaseDate" slot-scope="row"><label>{{formatDate(row.value)}}</label></template>
          <template slot="lastPurchaseDate" slot-scope="row"><label>{{formatDate(row.value)}}</label></template>
          <template slot="productImageUrl" slot-scope="row"><b-img class="image" :src="row.value"></b-img></template>
          <template slot="productCondition" slot-scope="row">
            <div><label>{{productConditionText(row.value)}}</label></div>
            <!-- <div v-show="row.item['hasShipped']"><label class="mark-red">割</label></div> -->
          </template>
          <template slot="janCode" slot-scope="row"><div class="word-break">{{row.value}}</div></template>
          <template slot="asinSku" slot-scope="row">
            <div><label>{{row.item['asin']}}</label></div>
            <div><label>{{row.item['sku']}}</label></div>
          </template>
          <template slot="price" slot-scope="row">
            <div><label>{{formatPrice(row.item['totalAmount'])}}</label></div>
            <div><label>({{formatPrice(row.item['purchaseUnitPrice'])}})</label></div>
          </template>
          <template slot="forcastShippingCost" slot-scope="row"><label>{{formatPrice(row.value)}}</label></template>
          <template slot="forcastTargetSales" slot-scope="row"><label>{{formatPrice(row.value)}}</label></template>
          <template slot="forcastTargetProfit" slot-scope="row"><label>{{formatPrice(row.value)}}</label></template>
          <template slot="matomeStatus" slot-scope="row">
            <b-checkbox size="sm" class="matome-status-mark" v-model="row.value" disabled></b-checkbox>
          </template>
          <template slot="weightInfo" slot-scope="row">
            <weight-type :type="row.item['weightType']"/>
            <div><label>{{getWeightValue(row.item)}}</label></div>
          </template>
          <template slot="inboundQuantity" slot-scope="row">
            <div><label>{{row.item['inboundQuantity']}}</label></div>
            <div v-show="row.item['lostQuantity'] !== 0"><label>({{row.item['lostQuantity']}})</label></div>
          </template>
          <template slot="comment" slot-scope="row">
            <div v-if="row.item['comment'] != null && row.item['comment'] != ''">{{row.item['comment']}}</div>
            <div v-if="row.item['lostComment'] != null && row.item['lostComment'] != ''">(不明品) {{row.item['lostComment']}}</div>
          </template>
          <template slot="status" slot-scope="row">
            <div v-for='(value, index) in getStatusList(row.item)' :key='index'>
              {{ value }}
            </div>
          </template>
          <template slot="additionalCount" slot-scope="row">
            <b-row>
              <!-- <b-col sm=12>
                <b-form-input v-model="row.item['additionalCount']" class="pw05" :disabled="!row.item['activeRecord']"></b-form-input>
              </b-col> -->
              <b-col sm=12>
                <b-form-input v-on:focus="focusInText(row.item)" v-on:blur="focusOutText(row.item)" v-model="row.item['additionalCount']" class="pw05" :disabled="!row.item['activeRecord']"></b-form-input>
              </b-col>
              <!-- <b-col sm=3 class="pl0 pr0">
                <b-button size="sm" @click="upAdditionalCount(row.item)" class="btn-100" variant="danger ">+</b-button>
              </b-col>
              <b-col sm=3 class="pl0">
                <b-button size="sm" @click="downAdditionalCount(row.item)" class="btn-100" variant="dark">‐</b-button>
              </b-col> -->
            </b-row>
          </template>
          <template slot="purchaseInfo" slot-scope="row">
            <div><label>{{row.item['purchaseQuantity']}}</label><label>({{row.item['childQuantityPerSet']}})</label></div>
            <b-button v-show="row.item['hasShipped']" class="mark-red2" v-b-popover.hover.top="dispSplitInbound(row.item)">一部発送済</b-button>
            <!-- <div v-show="row.item['hasShipped']"><label class="mark-red">割<span>{{row.item['purchaseQuantity']}}/{{row.item['purchaseQuantityOrg']}}</span></label></div> -->
          </template>
          <template slot="setLabel" slot-scope="row">
            <print-barcode-set-modal
              size="sm" :title="row.item['asin']" :memberId="memberId" :item="row.item" :status="row.item['status']" :url="row.item['barcodeUrl']" :variant="'info'" :janFilter="janFilter" :statusFilter="statusFilter" :moveFromProductMenu="moveFromProductMenu"
              @updateItems="$emit('updateItems', $event)"
            />
          </template>
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="editModal(row)" :disabled="!row.item['activeRecord']" variant="warning">更</b-button>
          </template>
          <!-- <template slot="trouble" slot-scope="row">
            <b-button size="sm" @click="troubleModal(row)" :disabled="!row.item['activeRecord']" variant="dark">管</b-button>
          </template> -->

          <template slot="history" slot-scope="row">
            <b-button  size="sm" :id="`popover-set-`+ row.index" variant="primary" :disabled="!authSlcUser">操</b-button>
            <b-popover
              :target="`popover-set-`+ row.index"
              :placement="placement"
              title="操作バー"
              triggers="click blur"
              :content="`popover-2-`+ row.index">
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickToKako(row)" size="md" :disabled="row.item['inboundQuantity'] === 0 || authSlcLiteUser" variant="danger">過去移動</b-button>
                </b-col>
              </b-row>
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickReturn(row)" size="md" :disabled="row.item['inboundQuantity'] === 0 || authSlcLiteUser" variant="danger">返品</b-button>
                </b-col>
              </b-row>
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickDelete(row)" size="md" :disabled="row.item['inboundQuantity'] === 0 || authSlcLiteUser" variant="danger">廃棄</b-button>
                </b-col>
              </b-row>
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickHoten(row)" size="md" :disabled="row.item['inboundQuantity'] == 0 || authSlcLiteUser" variant="danger">補填</b-button>
                </b-col>
              </b-row>
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickLost(row)" size="md" :disabled="row.item['inboundQuantity'] == 0 && row.item['lostQuantity'] == 0" variant="danger">不明</b-button>
                </b-col>
              </b-row>
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickDeleteRecord(row)" size="md" :disabled="authSlcLiteUser" variant="danger">削除</b-button>
                </b-col>
              </b-row>
              <!-- <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickResetRequestFix(row)" size="md" :disabled="row.item['status'].indexOf('08') == -1" variant="danger">修正削除依頼解除</b-button>
                </b-col>
              </b-row> -->
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickConfirmFixComment(row)" size="md" :disabled="row.item['status'].indexOf('28') == -1 || authSlcLiteUser" variant="danger">修正依頼コメント</b-button>
                </b-col>
              </b-row>
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickResetRequestFixSimple(row)" size="md" :disabled="row.item['status'].indexOf('28') == -1" variant="danger">修正依頼解除</b-button>
                </b-col>
              </b-row>
              <b-row class="component-margin-half">
                <b-col md="12">
                  <b-button class="it_max-width" @click="clickHistory(row)" size="md" :disabled="authSlcLiteUser" variant="danger">履歴</b-button>
                  <!-- <inbound-history-modal :item="row.item"/> -->
                </b-col>
              </b-row>
            </b-popover>
          </template>

        </b-table>
        <b-modal ref="editModal" title="入庫状況変更" @ok="handleOk">
          <b-form-group v-show="authSlcUser" size="sm" horizontal label="仕入日" label-class="text-sm-right" label-for="purchaseDate">
            <date-picker id="purchaseDate" class="table-linput" :value="editItem.purchaseDate" @change="($event) => editItem.purchaseDate = $event"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="子-JANコード" label-class="text-sm-right" label-for="janCode">
            <b-form-input size="sm" id="janCode" v-model="editItem.janCode" :disabled="editItem.inboundQuantity != '0'" type="text"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="SKU" label-class="text-sm-right" label-for="sku">
            <b-form-input size="sm" id="sku" v-model="editItem.sku" type="text" :disabled="!authSlcUser"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="購入数" label-class="text-sm-right" label-for="purchaseQuantity">
            <b-form-input size="sm" id="purchaseQuantity" v-model="editItem.purchaseQuantity" type="text" :disabled="!authSlcUser"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="単価" label-class="text-sm-right" label-for="purchaseUnitPrice">
            <b-form-input size="sm" id="purchaseUnitPrice" v-model="editItem.purchaseUnitPrice" type="text" :disabled="!authSlcUser"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="店舗名" label-class="text-sm-right" label-for="shopName">
            <b-form-input size="sm" id="shopName" v-model="editItem.shopName" type="text" :disabled="!authSlcUser"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="見込み送料" label-class="text-sm-right" label-for="forcastShippingCost">
            <b-form-input size="sm" id="forcastShippingCost" v-model="editItem.forcastShippingCost" type="text" :disabled="!authSlcUser"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="T売上" label-class="text-sm-right" label-for="forcastTargetSales">
            <b-form-input size="sm" id="forcastTargetSales" v-model="editItem.forcastTargetSales" type="text" :disabled="!authSlcUser"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="T利益" label-class="text-sm-right" label-for="forcastTargetProfit">
            <b-form-input size="sm" id="forcastTargetProfit" v-model="editItem.forcastTargetProfit" type="text" :disabled="!authSlcUser"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="入庫数" label-class="text-sm-right" label-for="inboundQuantity">
            <b-form-input size="sm" id="inboundQuantity" v-model="editItem.inboundQuantity" type="text" :disabled="!authSlcUser"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="コメント" label-class="text-sm-right" label-for="comment">
            <b-form-input size="sm" id="comment" v-model="editItem.comment" type="text"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="不明品コメント" label-class="text-sm-right" label-for="lostComment">
            <b-form-input size="sm" id="lostComment" v-model="editItem.lostComment" type="text"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="特殊便指定" label-class="text-sm-right" label-for="checkboxMatomeSetStatus">
            <b-form-checkbox size="sm" id="checkboxMatomeSetStatus" name="checkboxMatomeSetStatus" v-model="editItem.matomeStatus" :disabled="!authSlcUser"></b-form-checkbox>
          </b-form-group>
        </b-modal>
        <!-- <b-modal ref="troubleModal" title="管理品登録" @ok="handleTroubleOk" no-close-on-backdrop=true no-close-on-esc=true content-class="shadow">
          <b-form-group size="sm" horizontal label="問題内容" label-class="text-sm-right" label-for="troubleSelect">
            <b-form-radio-group v-model="selected" class="pt-2" :options="reasonTypes" label-for="troubleSelect"></b-form-radio-group>
          </b-form-group>
          <b-form-group size="sm" horizontal label="その他" label-class="text-sm-right" label-for="reasonCodeOther">
            <b-form-input size="sm" id="reasonCodeOther" v-model="reasonCodeOther" :disabled="selected != '12'" type="text"/>
          </b-form-group>
          <b-form-group size="sm" horizontal label="数量" label-class="text-sm-right" label-for="troubleQuantity">
            <b-form-input size="sm" id="troubleQuantity" v-model="troubleQuantity" type="text"/>
          </b-form-group>
        </b-modal> -->
        <b-modal ref="confirmMessage" ok-only hide-header>
          <div class="text-center"><label>{{confirmMessage}}</label></div>
        </b-modal>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col md="6">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import WeightType from '@/components/common/WeightType';
import PrintBarcodeModal from '@/components/inbound/PrintBarcodeModal';
import PrintBarcodeSetModal from '@/components/inbound/PrintBarcodeSetModal';
import PrintBarcodeModalSimple from '@/components/inbound/PrintBarcodeModalSimple';
import InboundHistoryModal from '@/components/inbound/InboundHistoryModal';
import InboundSummary from '@/components/inbound/InboundSummary';
import DatePicker from '@/components/common/DatePicker';
import ReasonType from '@/types/ReasonType';

export default {
  mixins: [BaseComponent],
  props: {
    items: {
      default: [],
    },
    setInfo: {
      default: [],
    },
    nameFilter: {
      default: '',
    },
    sizeFilter: {
      default: '8',
    },
    statusFilter: {
      default: '1',
    },
    inboundFilter: {
      default: '0',
    },
    memberId: {
      default: '',
    },
    authSlcUser: {
      default: false,
    },
    authSlcLiteUser: {
      default: false,
    },
    moveFromProductMenu: {
      default: false,
    },
    // isMemberId: {
    //   default: '0',
    // },
    janFilter: { default: ''},
    checkfilterInboundDate: { default: false },
    filterStartDate: { default: ''},
    filterEndDate: { default: ''}
  },
  data() {
    return {
      summaryItems: [],
      setFields: [
        { key: 'setParentAsin', label: 'ASIN', sortable: true, variant: 'base', class: 'table-rw7'},
        { key: 'setParentProductName', label: '商品名(英)', sortable: true, variant: 'base' },
        { key: 'janCode', label: 'JAN/(FNSKU)', sortable: true, variant: 'base', class: 'table-rw7'},
        { key: 'cproductNameJp', label: '商品名(JAN）', sortable: true, variant: 'base'},
        { key: 'cquantityPerSet', label: 'ロット', sortable: true, variant: 'base', class: 'table-lw6'},
        { key: 'preparedSetQuantity', label: '集約済SET数', sortable: true, variant: 'warning', class: 'table-lw8'},
        { key: 'remainSetQuantity', label: '未集約数量(SET)', sortable: true, variant: 'warning', class: 'table-lw9'},
        { key: 'pairFinalAbleSetQuantity', label: '集約可能SET数', sortable: true, variant: 'warning', class: 'table-lw9'},
        { key: 'additionalCountForSet', label: '+', sortable: true, variant: 'success', class: 'table-cw4'},
        { key: 'createSet', label: '-', sortable: true, variant: 'success', class: 'table-cw9'},
        { key: 'createSetMinus', label: '-', sortable: true, variant: 'success', class: 'table-cw9'},
        { key: 'printSetLabel', label: '-', sortable: false, variant: 'success', class: 'table-cw9'},
      ],
      fields: [
        { key: 'purchaseDate', label: '仕入日', sortable: true, variant: 'base', class: 'table-lw7' },
        { key: 'productImageUrl', label: '画像', sortable: false, variant: 'base', class: 'table-cw4' },
        { key: 'productCondition', label: '状態', sortable: true, variant: 'base', class: 'table-lw4' },
        { key: 'asinSku', label: 'ASIN/SKU', sortable: true, variant: 'base' },
        { key: 'productNameEn', label: '商品名(英)', sortable: true, variant: 'base' },
        { key: 'weightInfo', label: '重量(kg)', sortable: false, variant: 'base', class: 'table-rw3' },
        { key: 'janCode', label: '商品コード', sortable: true, variant: 'base', class: 'table-lw7' },
        { key: 'childProductNameJp', label: '商品名(日)', sortable: true, variant: 'base' },
        { key: 'purchaseInfo', label: '購入数(単数)', sortable: false, variant: 'base', class: 'table-rw5' },
        { key: 'price', label: '総額', sortable: true, variant: 'base', class: 'table-rw6' },
        { key: 'shopName', label: '店舗名', sortable: true, variant: 'base' },
        { key: 'forcastShippingCost', label: '見込送料', sortable: true, variant: 'warning', class: 'table-rw4' },
        { key: 'forcastTargetSales', label: 'T売上', sortable: true, variant: 'warning', class: 'table-rw6' },
        { key: 'forcastTargetProfit', label: 'T利益', sortable: true, variant: 'warning', class: 'table-rw5' },
        { key: 'lastPurchaseDate', label: '入庫日', sortable: true, variant: 'success', class: 'table-lw6' },
        { key: 'additionalCount', label: '✛', sortable: true, variant: 'success', class: 'table-cw4' },
        { key: 'inboundQuantity', label: '入庫', sortable: true, variant: 'success', class: 'table-rw2' },
        { key: 'unInboundQuantity', label: '未受', sortable: true, variant: 'success', class: 'table-rw2' },
        { key: 'status', label: 'STATUS', sortable: true, variant: 'success', class: 'table-lw7' },
        { key: 'comment', label: '備考', sortable: true, variant: 'success' },
        { key: 'matomeStatus', label: '特殊', sortable: true, variant: 'success' },
        { key: 'setLabel', label: 'ラベル', variant: 'success', class: 'table-cw4' },
        { key: 'update', label: '更', variant: 'success', class: 'table-cw3' },
        // { key: 'trouble', label: '管', variant: 'success', class: 'table-cw3' },
        { key: 'history', label: '操作', variant: 'success', class: 'table-cw3' },
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      activate: false,
      modalInfo: { title: '', content: '' },
      sizeTypeFilter: null,
      productStatusFilter: '1',
      sizeType: [
        { value: '0', text: '全サイズ' },
        { value: '1', text: 'light' },
        { value: '2', text: 'standard' },
        { value: '3', text: 'large' },
      ],
      conditionType: [
        { value: '0', text: 'NEW' },
        { value: '1', text: 'USED' },
      ],
      productStatus: [
        { value: '0', text: '全部' },
        { value: '1', text: '未発送' },
        { value: '2', text: '発送済' },
      ],
      editRowKey: null,
      selectedRowItem: {},
      modalInfo: { title: '', content: '' },
      editItem: {},
      reasonTypes: ReasonType.values3(),
      selected: '',
      reasonCodeOther: '',
      troubleQuantity: '',
      confirmMessage: '',
    };
  },
  computed: {
    filteredItems() {
        let filteredItems = this.items.filter(item => {
         return (((this.nameFilter === '' || (item.asin !== null && item.asin.toUpperCase().indexOf(this.nameFilter.toUpperCase()) !== -1) ||
                  (item.sku !== null && item.sku.toUpperCase().indexOf(this.nameFilter.toUpperCase()) !== -1) ||
                  (item.janCode !== null && item.janCode.toUpperCase().indexOf(this.nameFilter.toUpperCase()) !== -1) ||
                  (item.childProductNameJp !== null && item.childProductNameJp.toUpperCase().indexOf(this.nameFilter.toUpperCase()) !== -1) ||
                  (item.productNameEn !== null && item.productNameEn.toUpperCase().indexOf(this.nameFilter.toUpperCase()) !== -1)) &&
                 (this.sizeFilter === '8' || (item.weightType !== null && item.weightType === this.sizeFilter)) &&
                 (!this.checkfilterInboundDate || item.lastPurchaseDate === '' || (this.filterStartDate <= item.lastPurchaseDate && this.filterEndDate >= item.lastPurchaseDate)) &&
                 (this.inboundFilter === '0' || (this.inboundFilter !== null && this.inboundFilter === '1' && item.inboundQuantity > 0) ||
                 (this.inboundFilter !== null && this.inboundFilter === '2' && item.inboundQuantity === item.purchaseQuantity) ||
                 (this.inboundFilter !== null && this.inboundFilter === '3' && item.inboundQuantity !== item.purchaseQuantity)) &&
                  (this.statusFilter === '0' || (this.statusFilter === '1' && item.activeRecord) || (this.statusFilter === '2' && !item.activeRecord))));
        });
      this.summaryItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      this.$emit('changeTotalRows', this.totalRows);
      return filteredItems;
    },
    filteredSetItems() {
        let filteredSetItems = this.setInfo.filter(item => {
         return (this.nameFilter === '' || (item.setParentAsin !== null && item.setParentAsin.toUpperCase().indexOf(this.nameFilter.toUpperCase()) !== -1));
        });
      return filteredSetItems;
    },
  },
  methods: {
    clickReturn(row){
      this.$emit('returnRow', row.item);
    },
    clickDelete(row){
      this.$emit('deleteRow', row.item);
    },
    clickDeleteRecord(row){
      this.$emit('deleteRowRecord', row.item);
    },
    clickResetRequestFix(row){
      this.$emit('resetRequestFix', row.item);
    },
    clickResetRequestFixSimple(row){
      this.$emit('resetRequestFixSimple', row.item);
    },
    clickConfirmFixComment(row){
      this.$emit('confirmFixComment', row.item);
    },
    clickHoten(row){
      this.$emit('hotenRow', row.item);
    },
    clickLost(row){
      this.$emit('lostRow', row.item);
    },
    clickToKako(row){
      this.$emit('toKakoRow', row.item);
    },
    clickHistory(row){
      this.$emit('historyRow', row.item);
    },
    dispSplitInbound(item){
      var msg = item['purchaseQuantityOrg'] + ' 個中 ' + (item['purchaseQuantityOrg'] - item['purchaseQuantity']) + ' 個発送済';
      return msg;
    },
    // printBarcodeSet(item) {
    //   const WinPrint = window.open('', '', 'width=500,height=555,scrollbars=0,menuBar=0,toolbar=0,location=0,status=0');
    //   var con = item['productCondition'] === '0' ? 'NEW' : 'USED';
    //   var pname = item['setParentProductName'].substring(0, 25);
    //   var printUrl = '';
    //   var fnsku = item['fnsku'].replace('E', 'e');

    //         // ラベルに表示する会員番号を成形
    //   var memberNumber = this.memberId.substr(7);
    //   var memberNumberOne = this.memberId.substr(7,1);
    //   if(memberNumberOne.search(/[A-Z]/) >= 0){
    //     memberNumber = memberNumberOne + '_' + this.memberId.substr(8);
    //   }

    //   if(item['matomeStatus']){
    //     printUrl = '<div style="text-align:center"><img src="' + item['barcodeUrl'] + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>(' + memberNumber + ') <label style="background-color:black;color:white;border-radius:1rem;padding-left:0.5rem;padding-right:0.5rem">M</label></div>';
    //   } else{
    //     printUrl = '<div style="text-align:center"><img src="' + item['barcodeUrl'] + '" width="195" class=""></div><div style="font-size:9px;text-align:center;margin-top:1px;padding:0">' + fnsku + '</div><div style="height:5px;font-size:9px;text-align:center;margin-top:-5px;padding:0">[' + con + '] ' + pname +'<br>(' + memberNumber + ')</div>';
    //   }
    //   WinPrint.document.body.innerHTML = printUrl;

    //   const sleep = (waitSeconds) => {
    //     return new Promise(resolve => {
    //       setTimeout(() => {
    //         WinPrint.window.print();
    //         WinPrint.document.close();
    //         WinPrint.focus();
    //         WinPrint.close();
    //       }, waitSeconds)
    //     })
    //   }
    //   sleep(500);
    // },
    editModal(row) {
      // this.editItem = {};
      // Object.assign(this.editItem , row.item);
      this.editItem =  Object.assign({}, this.editItem , row.item);
      this.$refs.editModal.show();
    },
    // troubleModal(row) {
    //   // this.editItem = {};
    //   this.editItem =  Object.assign({}, this.editItem , row.item);
    //   // Object.assign(this.editItem , row.item);
    //   this.$refs.troubleModal.show();
    // },
    handleOk() {
       this.$emit('update', this.editItem);
    },
    // handleTroubleOk() {
    //    this.editItem.selected = this.selected;
    //    this.editItem.reasonCodeOther = this.reasonCodeOther;
    //    this.editItem.troubleQuantity = this.troubleQuantity;
    //    this.$emit('troubleUpdate', this.editItem);
    // },
    createSet(row) {
      //  this.printBarcodeSet(row.item);
       row.item['isPlus'] = '1';
       this.$emit('createSet', row.item);
    },
    createSetMinus(row) {
       row.item['isPlus'] = '0';
       this.$emit('createSet', row.item);
    },
    focusInText(item){
      if(item.additionalCount === 0 || item.additionalCount === '0'){
        item.additionalCount = '';
      }
    },
    focusOutText(item){
      if(item.additionalCount === ''){
        item.additionalCount = 0;
      }
    },
    upAdditionalCount(item){
      item.additionalCount = parseInt(item.additionalCount) + 1;
    },
    downAdditionalCount(item){
      if(item.additionalCount > '1'){
        item.additionalCount = parseInt(item.additionalCount) - 1;
      }
    },
    getStatusList(item) {
      let statusList = [];
      // 有効なレコードの処理
      if(item['activeRecord']){
        return ReasonType.getStatusStr(item['status']);
      }
      // 過去レコードの処理
      statusList.push(item['status']);
      return statusList;
    },
    getWeightValue(item){
      if(item.weightType !== null && item.weightType === '9'){
        return 0;
      }
      return item.weight;
    },
    productConditionText(row) {
      if (row ==='0') {  return 'NEW'; }
      if (row ==='1') {  return 'USED'; }
    },
  },
};

Vue.component('weight-type', WeightType);
Vue.component('print-barcode-modal', PrintBarcodeModal);
Vue.component('print-barcode-set-modal', PrintBarcodeSetModal);
Vue.component('print-barcode-modal-simple', PrintBarcodeModalSimple);
Vue.component('inbound-history-modal', InboundHistoryModal);
Vue.component('inbound-summary', InboundSummary);
Vue.component('date-picker', DatePicker);
</script>

<style>
.component-margin {
  margin-bottom: 1rem;
}
.it_max-width{
  width: 100%;
}
.word-break{
  word-break: break-word;
}
.mark-red {
    background-color: red;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
}
.mark-red2 {
    background-color: red;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.5rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
}
.pr0{
  padding-right: 0;
}
.pl0{
  padding-left: 0;
}
.btn-100{
  height: 100%;
}
.pw05{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.matome-status-mark .custom-control-input:disabled:checked~.custom-control-label:before {
    background-color: #ff0000cf;
}
@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
}
</style>

